import React, { useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { getInternalToken, getCustomer, generateOtp } from "../api/authApi";

const Login = () => {
  const [mobile, setMobile] = useState("");
  const [tncOpen, setTncOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [searchParams] = useSearchParams();
  const voucherCode = searchParams.get("voucherCode");
  const navigate = useNavigate();
  const submit = async (e) => {
    e.preventDefault();

    if (mobile.length !== 10) {
      toast.error("Enter valid mobile number");
      return;
    }

    if (!voucherCode) {
      toast.error(
        "The link you used is invalid or incomplete. Please use the original voucher link or contact support."
      );
      return;
    }

    try {
      setLoading(true);
      toast.loading("Processing...");

      const tokenRes = await getInternalToken();
      const token = tokenRes.access_token;

      const customerRes = await getCustomer(token, mobile);

      if (!customerRes.data) {
        toast.dismiss();
        toast.error("User not found");
        return;
      }

      if (mobile !== "9044112255") {
        await generateOtp({
          mobile: "+91" + mobile,
          authkey: "332811AofgzqKp5eeadc8dP1",
          otp_expiry: 15,
          template_id: "65115af8d6fc05216e79d6b2",
        });
      }

      toast.dismiss();
      toast.success("OTP Sent");

      navigate("/otp", {
        state: {
          mobile,
          token,
          customerCode: customerRes.data.customercode,
          voucherCode,
          email: customerRes.data.email,
          name: customerRes.data.name
        },
      });
    } catch {
      toast.dismiss();
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <main className="auth">
        <section className="auth__visual">
          <div className="brand">
            <div className="brand__logo">
              <img src="img/unity_bank_logo.svg" alt="Unity Bank Logo" />
            </div>
          </div>

          <img
            src="img/welcome_benefit.svg"
            alt="Cashback Illustration"
            className="auth__illustration"
          />
        </section>

        <section className="auth__form">
          <div className="card">
            <h1>Login</h1>
            <p className="subtitle">Enter Your Mobile Number</p>

            <form onSubmit={submit}>
              <input
                type="tel"
                maxLength="10"
                required
                placeholder="Mobile Number"
                value={mobile}
                onChange={(e) =>
                  setMobile(e.target.value.replace(/\D/g, ""))
                }
              />

              <button type="submit" disabled={loading}>
                {loading ? "Processing..." : "Next"}
              </button>

              <label className="checkbox">
                <input type="checkbox" required />
                <span>
                  I agree to{" "}
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setTncOpen(true);
                    }}
                  >
                    Terms &amp; Conditions
                  </a>
                </span>
              </label>
            </form>
          </div>
        </section>
      </main>

      {/* Overlay */}
      <div
        className={`tnc_overlay ${tncOpen ? "show" : ""}`}
        onClick={() => setTncOpen(false)}
      ></div>

      {/* Right Slide Modal */}
      <div className={`tnc_modal ${tncOpen ? "show" : ""}`}>
        <div className="tnc_header">
          <h3>Terms &amp; Conditions</h3>
          <button className="close_tnc" onClick={() => setTncOpen(false)}>×</button>
        </div>

        <div className="tnc_content">
          <div class="tnc_page">
            <h2>Terms & Conditions</h2>

            <p>
              These Terms and Conditions govern your participation in the promotional
              voucher program. By accessing or using this service, you agree to comply
              with and be bound by the following terms.
            </p>

            <h3>1. Eligibility</h3>
            <p>
              Participation in this promotion is limited to individuals who have received
              a valid voucher link from the issuing platform. The voucher is intended for
              personal use only and may not be transferred or resold.
            </p>

            <h3>2. Voucher Usage</h3>
            <ul>
              <li>Each voucher can be redeemed only once.</li>
              <li>The voucher must be redeemed within the validity period mentioned.</li>
              <li>Expired vouchers will not be accepted or reissued.</li>
              <li>Any misuse may lead to cancellation of the voucher.</li>
            </ul>

            <h3>3. Account Verification</h3>
            <p>
              Users must verify their identity using the registered mobile number and OTP
              verification process. Incorrect or fraudulent information may result in
              denial of voucher redemption.
            </p>

            <h3>4. Modification or Termination</h3>
            <p>
              The program organizer reserves the right to modify, suspend, or terminate
              the promotion at any time without prior notice if deemed necessary for
              security, legal, or operational reasons.
            </p>

            <h3>5. Limitation of Liability</h3>
            <p>
              The organizer shall not be responsible for any direct or indirect damages
              resulting from the use or inability to use the voucher, including technical
              issues, network problems, or system failures.
            </p>

            <h3>6. Privacy</h3>
            <p>
              Any personal information collected during the redemption process will be
              handled in accordance with the applicable data protection regulations and
              used solely for verification and service improvement purposes.
            </p>

            <h3>7. Governing Law</h3>
            <p>
              These terms shall be governed and interpreted in accordance with applicable
              laws. Any disputes arising from this promotion will be subject to the
              jurisdiction of the relevant courts.
            </p>

            <p>
              By continuing with the login and OTP verification process, you acknowledge
              that you have read, understood, and agreed to these Terms and Conditions.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;